import { GoogleOutlined } from '@ant-design/icons'
import { ProviderHelperClient } from '~/plugins/data-connector/helpers/provider.helper.client'
import { ProviderAuthenticationClient } from '../../../authentication/client'
import { ProviderClient } from '../../abstract/provider.client'
import { ProviderGoogleCalendarCommon } from '../common'

const authentication = ProviderAuthenticationClient.Oauth2({
  ...ProviderGoogleCalendarCommon.authentication,
  clientId: ProviderHelperClient.getEnvVariable('google', 'CLIENT_ID'),
})

export const ProviderGoogleCalendarClient: ProviderClient = {
  key: ProviderGoogleCalendarCommon.key,
  authentication,
  description: {
    label: 'Google Calendar',
    icon: <GoogleOutlined />,
    triggers: [],
    actions: [
      {
        key: 'findManyCalendars',
        label: 'Find many calendars',
        input: [],
        output: [
          {
            key: 'calendars',
          },
        ],
      },
      {
        key: 'findManyEvents',
        label: 'Find many events',
        input: [{ key: 'calendarId' }, { key: 'from' }, { key: 'to' }],
        output: [
          {
            key: 'events',
          },
        ],
      },
      {
        key: 'createEvent',
        label: 'Create event',
        input: [
          { key: 'calendarId' },
          { key: 'title' },
          { key: 'description' },
          { key: 'start' },
          { key: 'end' },
          { key: 'notify' },
          { key: 'attendeeEmails' },
        ],
        output: [{ key: 'event' }],
      },
    ],
  },
}
